import axIos from "axios";
import { emitNavigationRequest } from './navigationEvents'
import { createRequestId, sendFrontendEvent } from './telemetry'

// API URL from environment variable or default to localhost
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const instance = axIos.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json"
    }
});

function getAuthorization() {
    let Author = sessionStorage.getItem('Authorization')
    if (Author === null) return ''
    return Author
}

instance.interceptors.request.use(
    (config) => {
        const auth = getAuthorization()
        config.headers.authorization = auth ? `Bearer ${auth}` : ''
        if (!config.headers['X-Request-Id']) {
            config.headers['X-Request-Id'] = createRequestId()
        }
        return config
    }
)

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status
        const requestUrl = error?.config?.url || ''
        if (!requestUrl.includes('observability/frontend/event')) {
            sendFrontendEvent({
                level: 'warn',
                event: 'http_error',
                message: error?.message || 'HTTP request failed',
                requestId: error?.config?.headers?.['X-Request-Id'] || '',
                metadata: {
                    status,
                    method: error?.config?.method || '',
                    url: requestUrl
                }
            })
        }

        if (status === 401) {
            sessionStorage.removeItem('userRole')
            sessionStorage.removeItem('userName')
            sessionStorage.removeItem('Authorization')
            emitNavigationRequest('/login')
        } else if (status === 403) {
            emitNavigationRequest('/dashboard')
        }
        return Promise.reject(error)
    }
)

export default instance
